/**
 * DIFFY — Story Assembly
 * Alterna a classe .is-triggered quando cada palco cruza a viewport.
 * Compatível com múltiplas instâncias, Theme Editor e atualizações do Horizon.
 */
(function () {
  'use strict';

  var stageObservers = new WeakMap();
  var textTimers = new WeakMap();

  function parseTimeList(value) {
    return value.split(',').map(function (item) {
      var time = item.trim();
      return time.endsWith('ms') ? parseFloat(time) : parseFloat(time) * 1000;
    });
  }

  function getLongestTransition(stage) {
    var longest = 0;

    stage.querySelectorAll('.diffy-assembly__layer').forEach(function (layer) {
      var styles = window.getComputedStyle(layer);
      var durations = parseTimeList(styles.transitionDuration);
      var delays = parseTimeList(styles.transitionDelay);
      var count = Math.max(durations.length, delays.length);

      for (var index = 0; index < count; index += 1) {
        var duration = durations[index % durations.length] || 0;
        var delay = delays[index % delays.length] || 0;
        longest = Math.max(longest, duration + delay);
      }
    });

    return longest;
  }

  function clearTextTimer(section) {
    var timer = textTimers.get(section);
    if (timer) window.clearTimeout(timer);
    textTimers.delete(section);
  }

  function updateTextReveal(stage, isVisible) {
    var section = stage.closest('[data-diffy-assembly-section]');
    if (!section || section.dataset.revealText !== 'true') return;

    clearTextTimer(section);

    if (!isVisible) {
      section.classList.remove('is-text-visible');
      return;
    }

    var waitTime = getLongestTransition(stage) + 80;
    var timer = window.setTimeout(function () {
      section.classList.add('is-text-visible');
      textTimers.delete(section);
    }, waitTime);

    textTimers.set(section, timer);
  }

  function showFinalState(stage) {
    stage.classList.add('is-triggered');
    var section = stage.closest('[data-diffy-assembly-section]');
    if (section) section.classList.add('is-text-visible');
  }

  function initStage(stage) {
    if (!stage || stageObservers.has(stage)) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      !('IntersectionObserver' in window)
    ) {
      showFinalState(stage);
      stageObservers.set(stage, null);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var section = stage.closest('[data-diffy-assembly-section]');
          var shouldReplay = !section || section.dataset.animationReplay !== 'false';

          if (entry.isIntersecting) {
            stage.classList.add('is-triggered');
            updateTextReveal(stage, true);

            /* Modo execução única: mantém o estado final e encerra a observação. */
            if (!shouldReplay) observer.unobserve(stage);
          } else if (shouldReplay) {
            stage.classList.remove('is-triggered');
            updateTextReveal(stage, false);
          }
        });
      },
      {
        threshold: 0.35,
        rootMargin: '0px 0px -5% 0px'
      }
    );

    observer.observe(stage);
    stageObservers.set(stage, observer);
  }

  function scanForStages(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-diffy-stage]')) {
      initStage(scope);
    }

    scope.querySelectorAll('[data-diffy-stage]').forEach(initStage);
  }

  function start() {
    scanForStages(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) scanForStages(node);
      });
    });
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', function (event) {
    scanForStages(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-diffy-stage]').forEach(function (stage) {
      var observer = stageObservers.get(stage);
      if (observer) observer.disconnect();
      stageObservers.delete(stage);

      var section = stage.closest('[data-diffy-assembly-section]');
      if (section) clearTextTimer(section);
    });
  });
})();
